// Mock API service for development
// Replace with actual API calls when backend is ready

import { isMaintenanceMode as checkMaintenanceMode } from './content';

// MAINTENANCE MODE - FORCED TRUE for initial deployment
export const isMaintenanceMode = async () => {
  // FORCE MAINTENANCE MODE - DO NOT CHANGE WITHOUT USER APPROVAL
  return true;
};

const mockData = {
  latestRelease: {
    id: 1,
    title: "Neural Networks",
    artist: "CYPHER",
    cover: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400",
    duration: "4:32",
    genre: "Synthwave",
    releaseDate: "2024-12-15",
    description: "A journey through digital consciousness and electronic dreams."
  },
  
  upcomingReleases: [
    {
      id: 2,
      title: "Digital Horizon",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400",
      releaseDate: "2025-01-20",
      description: "Exploring the boundaries between reality and virtual space."
    },
    {
      id: 3,
      title: "Quantum Beats EP",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1571974599782-87624638275b?w=400",
      releaseDate: "2025-03-10",
      description: "An experimental collection of quantum-inspired compositions."
    }
  ],

  tracks: [
    {
      id: 1,
      title: "Neural Networks",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400",
      duration: "4:32",
      genre: "Synthwave",
      tags: ["electronic", "ambient", "cyberpunk"],
      audioUrl: "/audio/neural-networks.mp3"
    },
    {
      id: 4,
      title: "Neon Dreams",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?w=400",
      duration: "3:45",
      genre: "Synthwave",
      tags: ["neon", "retro", "atmospheric"],
      audioUrl: "/audio/neon-dreams.mp3"
    },
    {
      id: 5,
      title: "Binary Sunset",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1614149162883-504ce4d13909?w=400",
      duration: "5:12",
      genre: "Ambient",
      tags: ["chill", "space", "meditation"],
      audioUrl: "/audio/binary-sunset.mp3"
    },
    {
      id: 6,
      title: "Code Rain",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=400",
      duration: "4:01",
      genre: "Techno",
      tags: ["matrix", "glitch", "intense"],
      audioUrl: "/audio/code-rain.mp3"
    },
    {
      id: 7,
      title: "Virtual Reality",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
      duration: "3:28",
      genre: "Electronic",
      tags: ["vr", "immersive", "futuristic"],
      audioUrl: "/audio/virtual-reality.mp3"
    },
    {
      id: 8,
      title: "Cybernetic Soul",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400",
      duration: "4:55",
      genre: "Synthwave",
      tags: ["emotional", "cyber", "melodic"],
      audioUrl: "/audio/cybernetic-soul.mp3"
    }
  ],

  projects: [
    {
      id: 1,
      title: "Cyberpunk Chronicles",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400",
      trackCount: 8,
      duration: "32:45",
      releaseDate: "2024-11-01",
      description: "A complete journey through cyberpunk soundscapes",
      tracks: [1, 4, 5, 6, 7, 8, 9, 10]
    },
    {
      id: 2,
      title: "Ambient Spaces",
      artist: "CYPHER",
      cover: "https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=400",
      trackCount: 5,
      duration: "24:30",
      releaseDate: "2024-10-15",
      description: "Atmospheric compositions for deep contemplation",
      tracks: [5, 11, 12, 13, 14]
    }
  ]
};

// Simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Maintenance mode wrapper for API calls
const withMaintenanceCheck = (apiCall) => {
  return async (...args) => {
    const maintenanceMode = await isMaintenanceMode();
    if (maintenanceMode) {
      throw new Error('System is currently under maintenance. Please try again later.');
    }
    return apiCall(...args);
  };
};

export const fetchLatestRelease = withMaintenanceCheck(async () => {
  await delay(500);
  return mockData.latestRelease;
});

export const fetchUpcomingReleases = withMaintenanceCheck(async () => {
  await delay(700);
  return mockData.upcomingReleases;
});

export const fetchTracks = withMaintenanceCheck(async () => {
  await delay(800);
  return mockData.tracks;
});

export const fetchProjects = withMaintenanceCheck(async () => {
  await delay(600);
  return mockData.projects;
});

export const fetchTrackById = withMaintenanceCheck(async (id) => {
  await delay(300);
  return mockData.tracks.find(track => track.id === id);
});

export const fetchProjectById = withMaintenanceCheck(async (id) => {
  await delay(400);
  const project = mockData.projects.find(p => p.id === id);
  if (project) {
    const projectTracks = mockData.tracks.filter(track => 
      project.tracks.includes(track.id)
    );
    return { ...project, trackList: projectTracks };
  }
  return null;
});